import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#FAFAF5]">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#6B7F3E] hover:text-[#5A6B34] mb-6" data-testid="back-home-link">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>
        <h1 className="font-display text-4xl font-semibold text-[#1A201A] tracking-tight mb-8">Impressum</h1>
        <div className="prose prose-sm max-w-none space-y-4 text-[#2C3E2D]">
          <div>
            <h2 className="font-display font-medium text-lg text-[#1A201A]">Angaben gemäß § 5 TMG</h2>
            <p>
              {COMPANY.name}<br />
              Inhaber: {COMPANY.owner}<br />
              {COMPANY.address}
            </p>
          </div>
          <div>
            <h2 className="font-display font-medium text-lg text-[#1A201A]">Kontakt</h2>
            <p>
              E-Mail: {COMPANY.email}<br />
              Telefon: {COMPANY.phone}
            </p>
          </div>
          <div>
            <h2 className="font-display font-medium text-lg text-[#1A201A]">Verantwortlich für den Inhalt</h2>
            <p>{COMPANY.owner}, Anschrift wie oben</p>
          </div>
          <div>
            <h2 className="font-display font-medium text-lg text-[#1A201A]">Haftungsausschluss</h2>
            <p className="text-[#5C6B5D]">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
              externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
